import { getSubstitutionPlanState } from "@msuite/utils/substitutions";
import { guardString } from "@msuite/utils/strings";
import type { Substitution } from "@msuite/utils/types";
import { ProcessSubstitutionActive } from "@/sites/substitutions/substitutions/process-substitution-active";
import { ProcessSubstitutionExpired } from "@/sites/substitutions/substitutions/process-substitution-expired";
import { ProcessSubstitutionPending } from "@/sites/substitutions/substitutions/process-substitution-pending";

/** Props Interface */
interface ProcessSubstitutionPlanProps {
	substitution: Substitution;
}

export function ProcessSubstitutionPlan({ substitution }: ProcessSubstitutionPlanProps) {
	const { isActive, isPending, isExpired } = getSubstitutionPlanState(substitution);

	if (isExpired) return <ProcessSubstitutionExpired />;
	if (isPending) return <ProcessSubstitutionPending substitution={substitution} />;
	if (isActive) return <ProcessSubstitutionActive substitution={substitution} />;
	return guardString(null);
}
